export default __webpack_public_path__ + "static/pragicts-ai-sales-and-marketing-d97905b6f5d8a0da417b51c766ac5d44.jpg";